module.exports = __webpack_public_path__ + "img/customer-statement.f1182828.png";